<template>
  <div class="charts" ref="chart" :auto-resize="true"></div>
</template>

<script>
export default {
  name: "GasLineChart",
  props: ['data'],
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      let myChart = this.$echarts.init(this.$refs.chart, 'shine')
      let _this = this
      console.log("_this.data")
      console.log(_this.data)
      let currMax = Math.max(
        Math.max.apply(Math, _this.data.map(item => {
          return item.chno2
        }))
      )
      let currMin = Math.min(
        Math.min.apply(Math, _this.data.map(item => {
          return item.chno2
        }))
      )
      let option = {
        title: {
          text: '温度趋势变化图',
          padding: [30, 60],
          textStyle: {
            color: "#409EFF"
          },
          subtextStyle: {
            lineHeight: 15,
          }

        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = '时间：' + params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName +params[i].value + '℃'
            }
            return relVal
          }
        },
        legend: {
          data: ['温度']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _this.data.map(item => {
            return this.$moment(item.createTime).format('MM-DD HH:mm:ss')
          })
        },
        yAxis: {
          type: 'value',
          default: 0,
          position: 'right',
          // dataMax: Math.ceil(currMax),
          max: Math.floor(currMax), // 电流最大值2000
          min: Math.floor(currMin),
          axisLabel: {
            formatter:'{value} ℃'
          }
        },
        series: [
          {
            type: "line",
            name: '温度',
            data: _this.data.map(item => {
              return item.chno2
            }),
            showAllSymbol: false,
            markLine: {
              label: {
                show: true,
                position: 'start',
                color: '#c12e34',
                formatter: function (params) {
                  return '阀值\n' + params.value
                }
              },
              symbol: ['arrow', 'round']
            },
          }]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => {
        myChart.resize();
      })
    }
  }

}
</script>

<style scoped>
.charts {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/SmokeLineChart.vue